import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/madre.png";
import Imagen2 from "../../../images/modulo12/clasemixta.png";
import Imagen3 from "../../../images/modulo12/viaje.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad3 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[5];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[6].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[6].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[4].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[4].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5">
        <div className="row align-items-center mt-3">
          <div className="col-md-8 col-12 p-md-1 p-0 p-lg-3">
            <h2 className="mb-4">Yo soy de aquí, tú eres de allá</h2>

            <p>
              Los peruanos estamos acostumbrados a migrar, o sea, a dejar el
              lugar donde vivimos por otro.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-md-1 p-0 p-lg-3">
            <p>
              Muchos migran del campo a la ciudad para tener{" "}
              <strong>mejores oportunidades</strong>, por ejemplo, un mejor
              trabajo o una mejor educación para sus hijos. En nuestra aula,
              seguramente tenemos compañeros que vienen de otras localidades.
            </p>
          </div>

          <div className="col-md-8 col-12 p-md-1 p-0 p-lg-3">
            <p>
              También hay muchos peruanos que viajan al extranjero a trabajar.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen3} className="img-fluid w-100" alt="Peruanos" />
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>Lea el texto titulado Yo soy de aquí, tú eres de allá.</li>

          <li>
            Resalte que muchas personas migran del campo a la ciudad o a
            ciudades más grandes, como la capital de una provincia. En nuestro
            país, la ciudad de Lima concentra la mayor cantidad de servicios y
            actividades económicas y culturales, por ello recibe mayor cantidad
            de migrantes. En la región sur, ocurre lo mismo con la ciudad de
            Arequipa. Los peruanos también migramos a otros países; los países a
            los que más peruanos han migrado en los últimos tiempos son Chile,
            Bolivia y Estados Unidos.
          </li>

          <li>
            Debe quedar claro que la migración es un fenómeno frecuente en
            nuestro país.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
